import {Component} from '@angular/core';
import {NavController, NavParams} from 'ionic-angular';
import {UserService} from "../../app/services/user.service";
import {Coupon} from "../../app/classes/coupon";
import {AnalyticsService} from "../../app/services/analytics.service";

@Component({
  selector: 'page-coupons',
  templateUrl: 'coupons.html'
})
export class CouponsPage {
  public coupons: Coupon[] = [];
  public couponGroups: Array<Coupon[]> = [];
  public refreshTimer: any;
  public isLoading : boolean = true;
  public hasError : boolean = false;

  constructor(private analytics : AnalyticsService, public userService: UserService, public navCtrl: NavController, public navParams: NavParams) {
    userService.getCoupons().then(this.setCoupons.bind(this)).catch(this.errorHandler.bind(this));
    this.refreshTimer = setInterval(() => {
      userService.getCoupons().then(this.setCoupons.bind(this)).catch(this.errorHandler.bind(this));
    }, 10 * 1000)
  }

  ionViewWillLeave() {
    clearInterval(this.refreshTimer);
  }

  ionViewWillEnter(){
    this.analytics.trackView("Coupons");
  }

  sendCoupons(){

  }

  errorHandler(){
    this.hasError = true;
    this.isLoading = false;
  }


  setCoupons(coupons) {
    this.hasError = false;
    this.isLoading = false;
    if (coupons) {
      this.coupons = coupons.filter((coupon: Coupon) => {
        return !coupon.expired
      });
      let couponGroups = [];
      let couponGroup = [];
      for (let i = 0, len = this.coupons.length; i < len; i++) {
        couponGroup.push(this.coupons[i]);
        if (couponGroup.length == 10) {
          couponGroups.push(couponGroup);
          couponGroup = [];
        }
      }
      if (couponGroup.length) {
        couponGroups.push(couponGroup);
      }
      this.couponGroups = couponGroups;
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/coupons/coupons.ts